export default {"src":"https://static.spiritory.com/_next/static/media/auth3.8e00931e.svg","height":139,"width":138,"blurWidth":0,"blurHeight":0};